module.exports = __webpack_public_path__ + "media/vraag_1.564b2d11.mp3";